import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgModel, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppInfoService } from 'core/app-info/app-info.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';

@Component({
  selector: 'app-tool-notes-dialog',
  templateUrl: './tool-notes-dialog.component.html',
  styleUrls: ['./tool-notes-dialog.component.scss'],
  standalone: false
})
export class ToolNotesDialogComponent implements OnInit {
  isMobile: boolean;
  appStrings: AppLocalization;
  notes = '';
  bomNotes = '';
  readOnly: boolean;
  disableSaveButton: boolean;
  notesForm: UntypedFormGroup;
  @ViewChild('notesField') notesField: NgModel;

  constructor(
    private appInfoService: AppInfoService,
    private dialogRef: MatDialogRef<ToolNotesDialogComponent>,
    private fb: UntypedFormBuilder,
    private deviceService: DeviceDetectorService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.appStrings = this.appInfoService.appStrings;
    this.notes = data.notes;
    this.bomNotes = data.bomNotes;
    this.readOnly = data.readOnly;
    this.disableSaveButton = data.disableSaveButton;
  }

  ngOnInit() {
    this.notesForm = this.fb.group({
      lineNotes: [this.notes, Validators.maxLength(2000)],
      bomNotes: [this.bomNotes, Validators.maxLength(2000)]
    });
    if (this.readOnly) {
      this.notesForm.disable();
    }
  }

  closeAndSave() {
    if (this.notesForm.dirty) {
      this.dialogRef.close({ index: 1, data: this.notesForm.controls.lineNotes.value });
    } else {
      this.dialogRef.close({ index: 0 });
    }
  }

  close() {
    this.dialogRef.close({ index: 0 });
  }
}
